module.exports = __webpack_public_path__ + "static/media/close-button.c2729263.svg";